/**
 * The TanStack Query client (SPEC §3).
 *
 * Built by a function rather than as a module singleton so tests get a fresh
 * cache per case — and so the retry policy under test is the one that ships.
 */

import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './api'

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // A 4xx will not resolve itself, and retrying a 404 three times only
        // delays telling the user what happened.
        retry: (failureCount, error) =>
          error instanceof ApiError && !error.isRetryable ? false : failureCount < 2,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
    },
  })
}
